import styled from "@emotion/styled";

import {
  colors,
  Typography,
  Link,
  VStack,
  HStack,
  ColorIcon,
  Badge,
  customEvent,
  Image,
  getCdnImageSrc,
} from "goi_common";

import numberToLocalString from "@/utils/numberToLocalString";
import { Box } from "@chakra-ui/react";

import parlors_discount from "@/constants/parlors_discount_detail.json";
import { useMemo } from "react";
import HiddenSeoWrapper from "@/components/HiddenSeoWrapper";

interface ParlorItemProps {
  id: number;
  src?: string;
  name: string;
  address: string;
  price: number;
  type: "대학병원" | "공설" | "전문";
  description: string;
  sido?: string;
  serviceName?: string;
}

const ParlorItem = ({
  id,
  src,
  name,
  address,
  price,
  type,
  description,
  sido,
  serviceName,
}: ParlorItemProps) => {
  const discountParlor = useMemo(() => {
    if (sido === "21" || sido === "26" || sido === "38") {
      return {
        parlor_id: id,
        description: "20%이상 할인받을 수 있어요",
        memo: name,
      };
    }
    return parlors_discount.find((p) => p.parlor_id === Number(id));
  }, [id]);
  return (
    <BigParlorRoot
      href={`/parlor/${id}/`}
      onClick={() => {
        customEvent({
          newGtm: {
            path: "parlor_region",
            trigger_and_target: "parlor_item-uv_parlor_detail",
            text: name,
          },
        });
      }}
    >
      <VStack
        width="100%"
        as="figure"
        borderRadius={5}
        overflow="hidden"
        boxShadow="0 0 7px rgba(113, 120, 125, 0.2)"
        aria-label={name}
      >
        <VStack>
          <Description className="body3_r white">{description}</Description>

          <VStack
            position="relative"
            width="100%"
            height="200px"
            overflow="hidden"
            background="white"
          >
            <Box
              position="absolute"
              top="50%"
              left="50%"
              width="100%"
              transform="translate(-50%,-50%)"
            >
              <Image
                src={src ? src : getCdnImageSrc("platform/parlor/parlor-img-default-2.png")}
                width="600px"
                alt={name}
              />
            </Box>
          </VStack>
        </VStack>
        <VStack as="figcaption" gap={5} padding="12px 16px 18px" background={colors.white}>
          <h3 className="subtitle2_b gray600 font-ellipsis" aria-label={name}>
            {name}
          </h3>
          <HiddenSeoWrapper>추천드리는 {name} 장례식장의 정보 입니다.</HiddenSeoWrapper>
          <Box>
            {discountParlor && (
              <HStack gap="4px" alignItems="center" justifyContent="center" width="fit-content">
                <Box>
                  <ColorIcon
                    name="icon-medal-check-mono"
                    color={colors.green500}
                    width={36}
                    height={36}
                  />
                </Box>
                <VStack gap="2px" padding="6px 0">
                  <Box pt="5px" className="button_12_sb green500">
                    고이 빈소 할인 제휴 장례식장
                  </Box>
                  <Box className="body_14_m green450">({discountParlor?.description})</Box>
                </VStack>
              </HStack>
            )}
          </Box>
          <HStack alignItems="center">
            {/* <ColorIcon name="location" color={colors.green450} size={22} /> */}
            <p className="body3_r gray600">{address}</p>
          </HStack>
          <Badge typography={Typography.body3_r}>
            {serviceName ? `${serviceName} 예상 비용` : "빈소 평균비용"}{" "}
            {numberToLocalString(price)}원
          </Badge>
        </VStack>

        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          className="subtitle4 orange700"
          background="white"
          style={{ cursor: "pointer" }}
          padding="0 0 18px"
        >
          {serviceName ? "자세히 보기" : "무빈소, 가족장, 일반장 비용 및 시설 정보 확인하기"}
          <ColorIcon name="arrow_right_small" color={colors.orange700} width="12px" height="12px" />
        </Box>
      </VStack>
    </BigParlorRoot>
  );
};

const BigParlorRoot = styled(Link)`
  width: 100%;
`;

const Description = styled.div`
  position: absolute;
  bottom: 8px;
  left: 16px;
`;

export default ParlorItem;
